/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi-container/~/lodash/_stackHas.js
// module id = ./node_modules/victory-voronoi-container/node_modules/lodash/_stackHas.js
// module chunks = 1